module.exports = __webpack_public_path__ + "images/services/box-preview-logo.bd9cd6014569593dd225.svg";